import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledTypographyLarge = styled(Typography)(({ theme }) => ({
  fontWeight: "600",
  fontSize: "14px",
  color: theme.palette.text.primary
}))

export const StyledTypographyMedium = styled(Typography)(({ theme }) => ({
  fontWeight: "400",
  fontSize: "14px",
  color: (theme.palette as any).default[400]
}))
